import React from 'react';
import './FooterButton.less';
import {FooterCaption} from "elements/footer-caption/FooterCaption";

export const FooterButton = ({text, onClick}) => {
	return <button className="footer-button" onClick={onClick}>
		<FooterCaption text={text}/>
	</button>
}
